"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var moment = require("moment-timezone");
var utilsMixin = {
    computed: {
        _: function () { return _; },
        moment: function () { return moment; },
    },
};
exports.default = utilsMixin;
